//
//
//
//
//
//
//
//
import includes from 'lodash/includes';
export default {
  props: {
    elements: {
      type: Array,
      required: true
    },
    matches: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    moreElementsBefore: {
      type: Boolean,
      "default": false
    },
    moreElementsAfter: {
      type: Boolean,
      "default": false
    }
  },
  methods: {
    isMatch: function isMatch(e) {
      return includes(this.matches, e.search_index);
    },
    elementContent: function elementContent(e) {
      if (e.visible === '\n' || e.unit === '\n' || e.token === '\n') {
        return '</br>';
      } else {
        return this.$ncsElementContent(e);
      }
    }
  }
};